import { restClient } from '@/Core'
import type { Chat, User } from '../Contracts'
import { extractChatUsers, mapApiChat, type ApiChat } from '../Helpers/apiMappers'

interface ChatsResponse {
    items?: ApiChat[]
}

/**
 * All chats visible to the current user, newest activity first (backend
 * default sort). Also returns users embedded in chat participants so the
 * UserStore can resolve names of people outside the contacts list.
 *
 * forceRefresh: unreadCount/lastMessage change after every action, the
 * 30s GET cache of restClient would serve stale counters.
 */
export const LoadChatsTask = async (): Promise<{ chats: Chat[]; users: User[] }> => {
    const response = (await restClient.get(
        '/services/chat/chats',
        { searchParams: { limit: 100 } },
        { forceRefresh: true }
    )) as ChatsResponse | null

    const items = response?.items ?? []

    const usersById = new Map<string, User>()
    for (const item of items) {
        for (const user of extractChatUsers(item)) {
            usersById.set(user.id, user)
        }
    }

    return {
        chats: items.map(mapApiChat),
        users: [...usersById.values()],
    }
}
